import AuthenticationService from '@/services/AuthenticationService'
// import Vue from 'vue'

const state = {
  loaded: false,
  login_his: []
};

const actions = {
    async get_login_history({ commit, rootGetters }) {
        try {
          // window.console.log(store.getters);
          const token = rootGetters['user/token'];
          const resp = await AuthenticationService.get_login_history(token);
          if (resp.status == '200') {
            commit('setLoginHistory', resp.data.data)
          }
        } catch(err) {
            window.console.log(err)
          }
    },
    clear({ commit }) {
        commit('clear');
    }
};

const mutations = {
    setLoginHistory(state, _login_his) {
        state.login_his = _login_his;
        state.loaded  = true;
    },
    clear(state) {
        state.loaded = false;
        state.login_his = null;
    }
};

export const login_history = {
    namespaced: true,
    state,
    actions,
    mutations
};
